module.exports =
    () => `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" class="extended-profile-job__chevron">
    <path fill-rule="nonzero" d="M1.88 4L.5 5.4 9 14l8.5-8.6L16.12 4 9 11.2"/>
    </svg>`;
